export default "__VITE_ASSET__0a41eeb6__"